import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取美国清关详情列表
export function getUsCustomsClearanceDetailList(params) {
  return request({
    url: URL.booking.getUsCustomsClearanceDetailList,
    method: 'get',
    params
  })
}

// 获取美国清关详情列表（多个jobUuid）
export function getUsCustomsClearanceDetailListByJobUuids(params) {
  return request({
    url: URL.booking.getUsCustomsClearanceDetailListByJobUuids,
    method: 'get',
    params
  })
}

// 美国清关出口同步进口
export function usCustomsClearanceExportSyncImport(params) {
  return request({
    url: URL.booking.usCustomsClearanceExportSyncImport,
    method: 'post',
    params
  })
}
